module.exports = __webpack_public_path__ + "img/walking.311157e3.png";